<template>
	<admin-wallet owner-type="supplier" />
</template>

<script>
import AdminWallet from '@/views/AdminWallet.vue';

export default {
	name: 'AdminSupplierWallet',
	components: {
		AdminWallet,
	},
};
</script>
